
export const USER_INFO = "USER_INFO";
export const ERROR = "ERROR";
export const GET_SELECTED_MENU = "GET_SELECTED_MENU";
export const SUCCESS = "SUCCESS";
export const GET_TECHNOLOGIES = "GET_TECHNOLOGIES";
export const GET_MENUS="GET_MENUS"
export const GET_USER_PERMISSIONS="GET_USER_PERMISSIONS"
export const GET_ALL_STRUCTURE="GET_ALL_STRUCTURE"
export const GET_MY_STRUCTURE="GET_MY_STRUCTURE"
export const SYSTEM_SETTINGS="SYSTEM_SETTINGS"
export const GET_WHOLE_STRUCTURE="GET_WHOLE_STRUCTURE"


